import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import BaseModal from '../../../../components/modals/BaseModal';

function EnterPinModal(props) {
  const [pin, setPin] = useState('');
  const { t } = useTranslation();

  const handleEnterPin = () => {
    props.handleEnterPin(pin);
    props.onHide();
  };

  return (
    <BaseModal
      open={props.show}
      onClose={props.onHide}
      title={t(StringKeys.ENTER_PIN)}
      onSubmit={handleEnterPin}
      submitButtonText={t(StringKeys.ENTER)}
      size="sm"
      enableEnterKey={true}
    >
      <TextField
        fullWidth
        variant="outlined"
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        label={t(StringKeys.ENTER_PIN)}
        autoComplete="off"
        sx={{ mt: 2 }}
      />
    </BaseModal>
  );
}

export default EnterPinModal;
